import { render, staticRenderFns } from "./ExpiryNotificationConfirm.vue?vue&type=template&id=934363bc&scoped=true"
import script from "./ExpiryNotificationConfirm.vue?vue&type=script&lang=js"
export * from "./ExpiryNotificationConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934363bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('934363bc')) {
      api.createRecord('934363bc', component.options)
    } else {
      api.reload('934363bc', component.options)
    }
    module.hot.accept("./ExpiryNotificationConfirm.vue?vue&type=template&id=934363bc&scoped=true", function () {
      api.rerender('934363bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ExpiryNotificationConfirm.vue"
export default component.exports